const styles = theme => ({
  root: {
    display: 'flex',
    'flex-direction': 'column',
    '-ms-flex-direction': 'column',
    width: '100%',
    padding: '10px 35px',
  },
  label: { fontSize: 14, marginBottom: 5 },
  // formControl: { 'margin-top': theme.spacing.unit },
  group: {
    'flex-direction': 'row',
    '-ms-flex-direction': 'row',
  },
  item: { margin: -5 },
  checked: { color: '#2974FF !important' },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/meals/mealSwitch/MealSubselectionSwitchStyles.js